export default () => {
  return {
    type: 'VIDEO_LOGIN_STATUS_UPDATE',
  };
};
